<div appOnscrollAnimated [class]="class+ ' text-start'" style="direction: rtl;">
  <p class="  text-[38px]">{{ title }}</p>
   
</div>
